module.exports = __webpack_public_path__ + "static/media/peacechild-beta-01.cac8a58a.svg";